export enum InventoryReceiptActionModals {
  NONE = 'NONE',
  DELETE_INVENTORY_RECEIPT = 'DELETE_INVENTORY_RECEIPT',
  EDIT_INVENTORY_RECEIPT = 'EDIT_INVENTORY_RECEIPT',
  ADD_INVENTORY_RECEIPT = 'ADD_INVENTORY_RECEIPT',
}
